import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Schema } from '@rossum/api-client/schemas';
import { Workspace } from '@rossum/api-client/workspaces';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import { Button } from '@rossum/ui/material';
import { SettingsBreadcrumbs } from '../../../../containers/Settings/SettingsBreadcrumbs';
import { Queue } from '../../types/queue';
import { AddFieldDialog } from './AddFieldDialog';

type OverviewHeaderProps = {
  workspaces: Workspace[];
  queues: Queue[];
  schemas: Schema[];
  isLoadingFieldManagerData: boolean;
} & Pick<HeaderProps, 'scrollableDivRef'>;

export const OverviewHeader = ({
  workspaces,
  queues,
  schemas,
  isLoadingFieldManagerData,
  ...rest
}: OverviewHeaderProps) => {
  const intl = useIntl();

  const [showDialog, setShowDialog] = useState<boolean>(false);

  return (
    <>
      <Header
        {...rest}
        breadcrumbs={
          <SettingsBreadcrumbs
            breadcrumbs={[
              {
                label: intl.formatMessage({
                  id: 'features.fieldManager.overview.ui.header.title',
                }),
              },
            ]}
          />
        }
        title={intl.formatMessage({
          id: 'features.fieldManager.overview.ui.header.title',
        })}
        description={intl.formatMessage({
          id: 'features.fieldManager.overview.ui.header.subTitle',
        })}
        buttons={[
          <Button
            key="add-field"
            data-cy="fm-add-field-btn"
            variant="contained"
            disabled={isLoadingFieldManagerData}
            onClick={() => setShowDialog(true)}
          >
            {intl.formatMessage({
              id: 'features.fieldManager.overview.addFieldDialog.button.addField',
            })}
          </Button>,
        ]}
      />
      {isLoadingFieldManagerData ? null : (
        <AddFieldDialog
          open={showDialog}
          onClose={() => setShowDialog(false)}
          schemas={schemas}
          queues={queues}
          workspaces={workspaces}
        />
      )}
    </>
  );
};
